import React from "react";
import StoreProvider from "./StoreContext";
import StoreStockProvider from "./StoreStockContext";
import BucketProvider from "./GetBucketDetailsContext";

const GlobalContextProvider = ({ children }) => {
  return (
    <StoreProvider>
      <StoreStockProvider>
        <BucketProvider>{children}</BucketProvider>
      </StoreStockProvider>
    </StoreProvider>
  );
};

export default GlobalContextProvider;
